import { CardStyle, CardWrapperClassNames, CardWrapperProps } from './types';
import { cn, getColorway } from 'utils/styles';
import { CardStyleIndicator } from 'components/shared/Card/CardStyle';
import { getColorwayName } from 'utils/formatters';

const CardWrapper = ({ cardStyle, index, total, color, children, className, testId }: CardWrapperProps) => {
  const internalClassNames: CardWrapperClassNames = {
    wrapper: cn(
      'relative scroll-mt-[var(--height-nav)] min-w-xs sm:min-w-[425px]',
      'rounded-lg h-full max-h-[50rem] pt-6 sm:pt-12 sm:pb-0',
      getColorway(color),
      className?.wrapper,
    ),
    header: cn('empty:hidden mx-6 sm:mx-12', className?.header),
    content: cn(className?.content),
  };

  const testFixture = `${testId ?? 'card'}-wrapper`;

  return (
    <div role="group" aria-roledescription="slide" className={internalClassNames.wrapper} data-testid={testFixture}>
      <CardStyleIndicator
        color={getColorwayName(color)}
        cardStyle={cardStyle ?? CardStyle.None}
        index={index ?? 0}
        total={total ?? 0}
        data-testid={`${testFixture}-indicator`}
        className={internalClassNames.header}
      />

      <div className={internalClassNames.content}>{children}</div>
    </div>
  );
};

export default CardWrapper;
